
































import { Vue, Component } from 'vue-property-decorator';
import { namespace, State, Mutation } from 'vuex-class';

const yuShangModule = namespace('yuShang');
@Component
export default class User extends Vue {
  @yuShangModule.State('balance') balance: any;
  @yuShangModule.State('userInfo') userInfo: any;

  navArr = [
    {
      text: '消费记录',
      id: 1,
      path: '/20230901YSPX/user/consume',
    },
    {
      text: '在线充值',
      id: 2,
      path: '/20230901YSPX/user/top-up',
    },
    {
      text: '充值记录',
      id: 3,
      path: '/20230901YSPX/user/record',
    },
  ];
  get name() {
    return (
      (this.userInfo && this.userInfo.nickname) ||
      (this.userInfo && this.userInfo.username) ||
      '未登录'
    );
  }
  get avatar() {
    return (
      (this.userInfo && this.userInfo.userpic) ||
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg'
    );
  }
  get activeIndex() {
    return this.navArr.findIndex((item, index) =>
      this.$route.path.includes(item.path),
    );
  }

  handleClickNav(item: any) {
    if (this.$route.path.includes(item.path)) {
      // location.reload();
      return;
    }
    this.$router.push(item.path);
  }
}
